import { useLocation } from 'react-router-dom';

export const useIsDashboard = (): boolean => {
  const location = useLocation();
  const studentPaths = [
    '/dashboard', '/user', '/my-dashboard', '/profile',
    '/checkout', '/playground', '/tutorials',
    '/learning-path', '/placement-test',
    '/my-learning', '/certificates', '/my-profile',
    '/settings'
  ];
  return studentPaths.some(p => location.pathname.startsWith(p)) ||
    location.pathname.startsWith('/admin');
};

export const useIsAuthPage = (): boolean => {
  const location = useLocation();
  return ['/login', '/register'].includes(location.pathname);
};
